module.exports = __webpack_public_path__ + "static/charlene-fce9a1bfd3ff9ff575c437bf0937888c.svg";